import React from "react";
import styles from "./Printable.scss";
import classNames from "classnames";

const toCssContentString = (value) => {
    if (!value) return JSON.stringify("");

    const normalizedValue = String(value)
        .replace(/\\/g, "\\\\")
        .replace(/"/g, String.raw`\\"`)
        .replace(/\r?\n/g, "\\A ");
    return `"${normalizedValue}"`;
};

export const Printable = ({ children, withPaging = false, footerText }) => {
    const footerRule = `@page { @bottom-right { content: counter(page) "/" counter(pages); font-size: 9pt; } @bottom-left { content: ${toCssContentString(footerText)}; font-size: 9pt; } }`;

    return (
        <>
            {withPaging && <style>{footerRule}</style>}
            <div className={classNames(styles.printable, { [styles.withPaging]: withPaging })}>{children}</div>
        </>
    );
};
